enum ValuationResultType {
  Unknown = 0,
  Successful = 1,
  VehicleNotFound = 2,
  Error = 3
}

export default ValuationResultType;
